/**
 * Truncates a wallet address to the format 0x1234...abcd
 * @param address The full wallet address
 * @param startLength Number of characters to show at the start (default: 6)
 * @param endLength Number of characters to show at the end (default: 4)
 * @returns The truncated address or the original string if invalid
 */
export const truncateAddress = (address: string | null | undefined, startLength: number = 6, endLength: number = 4): string => {
  if (!address) return '';
  if (address.length <= startLength + endLength) return address;
  
  return `${address.slice(0, startLength)}...${address.slice(-endLength)}`;
};